/**
 * Inbox reads + the batch delete: the `/api/v1/inbox` wire contract.
 *
 *  - `GET  /api/v1/inbox`              → `InboxMessageLight[]` (bare array —
 *    the shape the web's realtime / optimistic writers splice into the
 *    `['inbox-messages']` cache), every message of the CALLER (user-scoped
 *    RLS), newest first (`received_at` desc, `id` desc), keyset-paged on the
 *    server so PostgREST's 1,000-row cap never truncates it.
 *  - `GET  /api/v1/inbox/:id`          → one `InboxMessageLight` (404 when the
 *    caller has no such message). Same select as the list, so a realtime
 *    INSERT spliced into the cache cannot drift from a listed row.
 *  - `POST /api/v1/inbox/batch-delete` → body {@link inboxBatchDeleteSchema},
 *    response {@link InboxBatchDeleteResponse}.
 *  - `DELETE /api/v1/inbox/:id`        → {@link InboxDeleteResponse}, 404 when
 *    nothing was deleted.
 *
 * Deleting an email also deletes its files (the attachments and the rendered
 * email PDF: `files` rows + storage objects) unless another record still
 * references a file. A file clean-up failure never un-deletes the email: the
 * row's result carries `files_cleanup_failed: true` instead.
 *
 * The list select itself lives in the route module (one constant); this file
 * only describes what crosses the wire.
 */
import { z } from "zod";
/** Max email ids per batch-delete request (the web queues larger selections). */
export const INBOX_BATCH_DELETE_MAX_IDS = 100;
/** Request body of `POST /api/v1/inbox/batch-delete`. Duplicates are refused. */
export const inboxBatchDeleteSchema = z
    .object({
    message_ids: z
        .array(z.string().uuid())
        .min(1)
        .max(INBOX_BATCH_DELETE_MAX_IDS)
        .refine((ids) => new Set(ids).size === ids.length, {
        message: "message_ids must be unique",
    }),
})
    .strict();
//# sourceMappingURL=inboxReads.js.map